import {
  ChangeDetectionStrategy,
  Component,
  computed,
  input,
  InputSignal,
  output,
  OutputEmitterRef,
  Signal,
  ViewEncapsulation,
} from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import {
  faLightbulbOn,
  faStar,
  IconDefinition,
} from '@fortawesome/pro-solid-svg-icons';
import {
  ButtonFill,
  ComponentStatus,
  ExerciseResult,
} from '@lyceo/shared/util-models';
import { CdkAccordion } from '@angular/cdk/accordion';
import {
  AccordionItemComponent,
  ButtonComponent,
  DateFormatPipe,
} from '@lyceo/shared/ui';

@Component({
  selector: 'lyceo-exercise-card',
  imports: [
    ButtonComponent,
    FaIconComponent,
    CdkAccordion,
    AccordionItemComponent,
    DateFormatPipe,
  ],
  templateUrl: './exercise-card.component.html',
  styleUrls: ['./exercise-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  host: {
    'class': 'lyceo-exercise-card',
    '[class.exercise-type-normal]': 'normal',
    '[class.exercise-type-bonus]': 'bonus',
  },
})
export class ExerciseCardComponent {
  public readonly exerciseType: InputSignal<'NORMAL' | 'BONUS'> =
    input.required<'NORMAL' | 'BONUS'>();
  public readonly mainTitle: InputSignal<string> = input.required();
  public readonly text: InputSignal<string> = input.required<string>();
  public readonly buttonText: InputSignal<string> = input.required<string>();
  public readonly loading: InputSignal<boolean> = input<boolean>(false);
  public readonly results: InputSignal<ExerciseResult[]> = input<
    ExerciseResult[]
  >([]);

  public readonly buttonClick: OutputEmitterRef<void> = output();
  public readonly viewResults: OutputEmitterRef<ExerciseResult> = output();

  protected readonly ButtonFill: typeof ButtonFill = ButtonFill;

  protected readonly buttonStatus: Signal<
    ComponentStatus.PRIMARY | ComponentStatus.WARNING
  > = computed(() =>
    this.exerciseType() === 'BONUS'
      ? ComponentStatus.WARNING
      : ComponentStatus.PRIMARY,
  );
  protected readonly icon: Signal<IconDefinition> = computed(() =>
    this.exerciseType() === 'BONUS' ? faStar : faLightbulbOn,
  );

  public get normal(): boolean {
    return this.exerciseType() === 'NORMAL';
  }

  public get bonus(): boolean {
    return this.exerciseType() === 'BONUS';
  }
}
